import { render, staticRenderFns } from "./SidebarListGroup.vue?vue&type=template&id=1c9179d2&"
import script from "./SidebarListGroup.vue?vue&type=script&lang=js&"
export * from "./SidebarListGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports